// Deprecated - use PathHelper instead
class PathRouter {
    static HOME_PATH: string = "/"
    static LOGIN_PATH: string = "/login"
    static TERMS_OF_USE_PATH: string = "/terms"
    static CONTACT_US_PATH: string = "/contact"
    static VALUATION_PATH: string = "/valuation"

    static REMOVED_HOMES_PARAM: string = "removed_homes"
    static HOUSE_CONDITION_PARAM: string = "house_condition"
    static ADDRESS_PARAM: string = "address"
    static PROPERTY_ID_PARAM: string = "property_id"
    static SAVED_VALUATIONS_PATH: string = "/saved-valuations"

    ALLOWED_PARAM_FIELDS = [
        PathRouter.PROPERTY_ID_PARAM,
        PathRouter.REMOVED_HOMES_PARAM,
        PathRouter.HOUSE_CONDITION_PARAM,
        PathRouter.ADDRESS_PARAM
    ]

    ALLOWED_PATHS = new Set(
        [
            PathRouter.HOME_PATH, 
            PathRouter.LOGIN_PATH, 
            PathRouter.TERMS_OF_USE_PATH,
            PathRouter.CONTACT_US_PATH,
            PathRouter.VALUATION_PATH,
            PathRouter.SAVED_VALUATIONS_PATH,
        ]
    )

    PathRouter() {}

    getRoute(current_path: string) {
        let path: any = this.getPath()
        if (this.ALLOWED_PATHS.has(path)) {
            return path
        }
        return current_path
    }

    getParams() {
        let url = window.location.href;
        let urlObj = new URL(url);
        let params: any = {}
        for (let field of this.ALLOWED_PARAM_FIELDS) {
            let entry = urlObj.searchParams.get(field);
            if (entry) {
                params[field] = entry
            }
        } 
        return params
    }

    getPath() {
        let url = window.location.href;
        let urlObj = new URL(url);
        return urlObj.searchParams.get('path');
    }
}

export default PathRouter
